document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initMarquee();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-mt-contador')) || 0;
      obs.unobserve(el);
      if (prefersReduced) {
        el.textContent = fin;
        return;
      }
      var inicio = 0;
      var duracion = 1400;
      var t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var progreso = Math.min((t - t0) / duracion, 1);
        var valor = Math.round(inicio + (fin - inicio) * (1 - Math.pow(1 - progreso, 3)));
        el.textContent = valor;
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquee() {
  var tracks = document.querySelectorAll('.mt-marquee-track');
  if (!tracks.length) return;
  tracks.forEach(function (track) {
    if (track.children.length && !track.dataset.mtCloned) {
      track.innerHTML += track.innerHTML;
      track.dataset.mtCloned = '1';
    }
  });
}
